import React from "react";

import { translate, Responsive } from "react-admin";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Tooltip from "@material-ui/core/Tooltip";
import ContentRedo from "@material-ui/icons/Redo";

import myRestClient from "../../common/restClient";

import TranslatedText from "../../components/TranslatedText";
import { InstallationEventStatus } from "../../common/statuses";

class RedoProvisioningButton extends React.Component {
    state = { showSnackBar: false, error: false, err_msg: "" };

    startProvisioning = () => {
        const { record } = this.props;
        const mymessage = this.props.translate(
            "resources.installations.actions.redo_provisioning_message"
        );
        const createRecord = {
            data: {
                installation_id: record.id,
                type: InstallationEventStatus.provisioningRestarted,
                message: mymessage,
                short_desc: mymessage
            }
        };
        myRestClient("CREATE", "events", createRecord).then(
            () => {
                this.setState({ showSnackBar: true });
            },
            error => {
                this.setState({
                    error: true,
                    showSnackBar: true,
                    err_msg: error.body.message
                });
                return;
            }
        );
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({ error: false, showSnackBar: false })
                }
            />
        );
    }

    renderSnackMessage() {
        const err_msg_display = this.state.err_msg;
        return this.state.error === false ? (
            <span id="snack-message">
                <TranslatedText resource_name="resources.installations.actions.provisioningCommandSent" />
            </span>
        ) : (
            <span id="snack-message">
                <TranslatedText
                    resource_name={
                        this.state.err_msg
                            ? err_msg_display
                            : "resources.installations.actions.provisioningCommandError"
                    }
                />
            </span>
        );
    }

    render() {
        return (
            <span>
                <Button
                    color="primary"
                    target="_Blank"
                    onClick={this.startProvisioning}
                >
                    <Responsive
                        small={
                            <Tooltip
                                title={
                                    <TranslatedText resource_name="resources.installations.actions.replayProvisioning" />
                                }
                            >
                                <ContentRedo />
                            </Tooltip>
                        }
                        medium={<ContentRedo />}
                    />
                    <Responsive
                        small={<span />}
                        medium={
                            <span style={{ paddingLeft: "0.5em" }}>
                                <TranslatedText resource_name="resources.installations.actions.replayProvisioning" />
                            </span>
                        }
                    />
                </Button>
                {this.renderSnackBar()}
            </span>
        );
    }
}

export default translate(RedoProvisioningButton);



// WEBPACK FOOTER //
// ./src/resources/Installations/RedoProvisioningButton.js